(function() {
  'use strict';

  // Initialize Splide sliders when DOM is ready
  function initProductGallerySliders() {
    const gallerySliders = document.querySelectorAll('.product-gallery-slider');
    
    gallerySliders.forEach(function(slider) {
      debugger
      const blockId = slider.getAttribute('data-slider-id');
      const mainSliderId = '#main-slider-' + blockId.replace('product-gallery-', '');
      const thumbnailSliderId = '#thumbnail-slider-' + blockId.replace('product-gallery-', '');
      
      const mainSlider = document.querySelector(mainSliderId);
      const thumbnailSlider = document.querySelector(thumbnailSliderId);
      
      if (!mainSlider) return;
      
      // Initialize main slider
      const mainSplide = new Splide(mainSliderId, {
        type: 'slide',
        rewind: true,
        pagination: false,
        arrows: true,
        gap: '1rem',
        perPage: 1,
        perMove: 1,
        breakpoints: {
          640: {
            arrows: true,
          }
        }
      });
      
      // Initialize thumbnail slider if it exists
      if (thumbnailSlider) {
        const thumbnailSplide = new Splide(thumbnailSliderId, {
          type: 'slide',
          rewind: true,
          fixedWidth: 80,
          fixedHeight: 80,
          isNavigation: true,
          gap: 10,
          pagination: false,
          arrows: false,
          cover: true,
          breakpoints: {
            640: {
              fixedWidth: 80,
              fixedHeight: 80,
            }
          }
        });
        
        // Function to update active state
        function updateActiveThumbnail(index) {
          const thumbnailSlides = thumbnailSlider.querySelectorAll('.splide__slide');
          thumbnailSlides.forEach(function(slide, i) {
            if (i === index) {
              slide.classList.add('is-active');
            } else {
              slide.classList.remove('is-active');
            }
          });
        }
        
        // Add event listeners before mounting
        mainSplide.on('moved', function(newIndex) {
          updateActiveThumbnail(newIndex);
        });
        
        // Sync main slider with thumbnail slider (before mounting)
        mainSplide.sync(thumbnailSplide);
        
        // Mount main slider
        mainSplide.mount();

        // Mount thumbnail slider first
        thumbnailSplide.mount();

        // Add click handlers to thumbnail slides after both are mounted
        setTimeout(function() {
          const thumbnailSlides = thumbnailSlider.querySelectorAll('.splide__slide');
          thumbnailSlides.forEach(function(slide, index) {
            slide.style.cursor = 'pointer';
            // Remove existing click handlers to avoid duplicates
            const newSlide = slide.cloneNode(true);
            slide.parentNode.replaceChild(newSlide, slide);
            newSlide.addEventListener('click', function() {
              mainSplide.go(index);
            });
          });
          
          // Set initial active state
          updateActiveThumbnail(mainSplide.index || 0);
        }, 150);
        
        // Return early since we mounted main slider here
        return;
      } else {
        // No thumbnail slider, just mount main slider
        mainSplide.mount();
      }
    });
  }

  // Quantity control functions
  function increaseQuantity(button) {
    const input = button.previousElementSibling;
    if (!input || input.type !== 'number') return;
    
    const currentValue = parseInt(input.value) || 1;
    input.value = currentValue + 1;
    updateQuantity(input);
  }

  function decreaseQuantity(button) {
    const input = button.nextElementSibling;
    if (!input || input.type !== 'number') return;
    
    const currentValue = parseInt(input.value) || 1;
    if (currentValue > 1) {
      input.value = currentValue - 1;
      updateQuantity(input);
    }
  }

  function updateQuantity(input) {
    const quantity = parseInt(input.value) || 1;
    if (quantity < 1) {
      input.value = 1;
    }
    // Update price per serving if needed
    const container = input.closest('.px-4') || input.closest('.space-y-4');
    if (container) {
      const button = container.querySelector('button[data-add-to-cart]');
      if (button) {
        // You can add logic here to update the serving price based on quantity
        // const basePrice = parseFloat(button.dataset.basePrice || 0);
        // const servingPrice = (basePrice / quantity).toFixed(2);
        // const servingPriceElement = container.querySelector('.serving-price');
        // if (servingPriceElement) {
        //   servingPriceElement.textContent = '$' + servingPrice;
        // }
      }
    }
  }

  function addToCart(button) {
    const container = button.closest('.px-4') || button.closest('.space-y-4');
    if (!container) return;
    
    const quantityInput = container.querySelector('input[type="number"]');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    
    // Add your add to cart logic here
    console.log('Adding to cart:', quantity);
    
    // Example: You might want to integrate with Shopify's cart API
    // const productId = button.dataset.productId;
    // if (productId) {
    //   fetch('/cart/add.js', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify({
    //       id: productId,
    //       quantity: quantity
    //     })
    //   })
    //   .then(response => response.json())
    //   .then(data => {
    //     console.log('Added to cart:', data);
    //     // Update cart UI or show notification
    //   })
    //   .catch(error => {
    //     console.error('Error adding to cart:', error);
    //   });
    // }
  }

  // Attach event listeners
  function attachEventListeners() {
    // Use event delegation for quantity buttons
    document.addEventListener('click', function(e) {
      if (e.target.matches('[data-increase-quantity]') || 
          (e.target.closest('[data-increase-quantity]'))) {
        const button = e.target.matches('[data-increase-quantity]') 
          ? e.target 
          : e.target.closest('[data-increase-quantity]');
        increaseQuantity(button);
      }
      
      if (e.target.matches('[data-decrease-quantity]') || 
          (e.target.closest('[data-decrease-quantity]'))) {
        const button = e.target.matches('[data-decrease-quantity]') 
          ? e.target 
          : e.target.closest('[data-decrease-quantity]');
        decreaseQuantity(button);
      }
      
      if (e.target.matches('[data-add-to-cart]') || 
          (e.target.closest('[data-add-to-cart]'))) {
        const button = e.target.matches('[data-add-to-cart]') 
          ? e.target 
          : e.target.closest('[data-add-to-cart]');
        addToCart(button);
      }
    });
    
    // Handle quantity input changes
    document.addEventListener('change', function(e) {
      if (e.target.type === 'number' && e.target.closest('.product-gallery-slider, .px-4')) {
        updateQuantity(e.target);
      }
    });
  }

  // Countdown timer functionality
  let countdownIntervals = [];

  function formatDate(date) {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 
                    'July', 'August', 'September', 'October', 'November', 'December'];
    return months[date.getMonth()] + ' ' + date.getDate();
  }

  function initShippingDates() {
    const shippingDateElements = document.querySelectorAll('.shipping-date-text');
    
    shippingDateElements.forEach(function(element) {
      const shippingDays = parseInt(element.getAttribute('data-shipping-days')) || 0;
      const cutoffHour = parseInt(element.getAttribute('data-cutoff-hour')) || 17;
      const cutoffMinute = parseInt(element.getAttribute('data-cutoff-minute')) || 0;
      
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const cutoffTime = new Date(today);
      cutoffTime.setHours(cutoffHour, cutoffMinute, 0, 0);
      
      // Check if we're past the cutoff time
      let actualShippingDays = shippingDays;
      if (now >= cutoffTime) {
        // Past cutoff, add one more day
        actualShippingDays = shippingDays + 1;
      }
      
      // Calculate shipping date
      const shippingDate = new Date(now);
      shippingDate.setDate(shippingDate.getDate() + actualShippingDays);
      
      // Format the text
      let dateText = '';
      if (actualShippingDays === 0) {
        dateText = 'Ships today, ' + formatDate(shippingDate);
      } else if (actualShippingDays === 1) {
        dateText = 'Ships tomorrow, ' + formatDate(shippingDate);
      } else {
        dateText = 'Ships in ' + actualShippingDays + ' days, ' + formatDate(shippingDate);
      }
      
      element.textContent = dateText;
    });
  }

  function initCountdownTimers() {
    // Clear existing intervals
    countdownIntervals.forEach(function(interval) {
      clearInterval(interval);
    });
    countdownIntervals = [];

    const countdownElements = document.querySelectorAll('.countdown-timer');
    
    countdownElements.forEach(function(element) {
      const cutoffHour = parseInt(element.getAttribute('data-cutoff-hour')) || 17;
      const cutoffMinute = parseInt(element.getAttribute('data-cutoff-minute')) || 0;
      
      function updateCountdown() {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const cutoffTime = new Date(today);
        cutoffTime.setHours(cutoffHour, cutoffMinute, 0, 0);
        
        // Determine if we should use today's or tomorrow's cutoff
        let targetCutoff = new Date(cutoffTime);
        if (now >= cutoffTime) {
          // Past today's cutoff, use tomorrow's cutoff
          targetCutoff.setDate(targetCutoff.getDate() + 1);
        }
        
        const timeRemaining = targetCutoff - now;
        
        if (timeRemaining <= 0) {
          // Countdown expired, reset to next day
          targetCutoff.setDate(targetCutoff.getDate() + 1);
          const newTimeRemaining = targetCutoff - now;
          updateDisplay(element, newTimeRemaining);
          // Also update shipping date when countdown resets
          initShippingDates();
        } else {
          updateDisplay(element, timeRemaining);
        }
      }
      
      // Update immediately
      updateCountdown();
      
      // Update every second
      const interval = setInterval(updateCountdown, 1000);
      countdownIntervals.push(interval);
    });
  }

  function updateDisplay(element, timeRemaining) {
    const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
    
    const hoursText = hours > 0 ? hours + 'hr ' : '';
    const minutesText = minutes > 0 ? minutes + 'mins ' : '';
    const secondsText = seconds + ' sec';
    
    element.textContent = hoursText + minutesText + secondsText;
  }

  // Smooth scroll to section with offset
  function initSmoothScroll() {
    // Handle all anchor tags with href="#pq-product-offer"
    document.addEventListener('click', function(e) {
      const anchor = e.target.closest('a[href="#pq-product-offer"]');
      
      if (anchor) {
        e.preventDefault();
        
        const targetSection = document.getElementById('pq-product-offer');
        if (targetSection) {
          const offset = 300; // 100px offset (scroll down)
          const elementPosition = targetSection.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset + offset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }
    });
    
    // Also handle hash changes in URL (e.g., when page loads with #pq-product-offer)
    function handleHashScroll() {
      if (window.location.hash === '#pq-product-offer') {
        const targetSection = document.getElementById('pq-product-offer');
        if (targetSection) {
          const offset = 300; // 100px offset (scroll down)
          const elementPosition = targetSection.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset + offset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }
    }
    
    // Handle hash on page load
    if (window.location.hash === '#pq-product-offer') {
      setTimeout(handleHashScroll, 100);
    }
    
    // Handle hash changes
    window.addEventListener('hashchange', handleHashScroll);
  }

  // Make functions globally available for onclick handlers
  window.increaseQuantity = increaseQuantity;
  window.decreaseQuantity = decreaseQuantity;
  window.updateQuantity = updateQuantity;
  window.addToCart = addToCart;

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initProductGallerySliders();
      attachEventListeners();
      initShippingDates();
      initCountdownTimers();
      initSmoothScroll();
    });
  } else {
    initProductGallerySliders();
    attachEventListeners();
    initShippingDates();
    initCountdownTimers();
    initSmoothScroll();
  }

  // Re-initialize sliders if content is dynamically loaded (e.g., Shopify sections)
  if (typeof document.addEventListener !== 'undefined') {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId && document.querySelector('.product-gallery-slider')) {
        setTimeout(function() {
          initProductGallerySliders();
          initShippingDates();
          initCountdownTimers();
        }, 100);
      }
    });
  }
})();

